module.exports = __webpack_public_path__ + "static/KMN_Desktop-0a067817c4af4154d1924e3523521d42.png";